import { render, staticRenderFns } from "./CollectEnd.vue?vue&type=template&id=56b080d8&scoped=true"
import script from "./CollectEnd.vue?vue&type=script&lang=js"
export * from "./CollectEnd.vue?vue&type=script&lang=js"
import style0 from "./CollectEnd.vue?vue&type=style&index=0&id=56b080d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b080d8",
  null
  
)

export default component.exports